import type { FunctionComponent } from "react";

import { Tabs, Tab } from "@similarweb/ui-components";

import { useSelectedPageTab } from "app/custom-hooks/useSelectedPageTab";
import { translate } from "app/filters/i18nFilter";
import { SerpPlayers } from "app/pages/keyword-research/keyword-analysis/pages/serp-players/SerpPlayers";
import { isPaidKwSearchAvailable } from "app/pages/keyword-research/utils/permissions";
import { TabListStyled } from "app/components/keyword-research/landing-pages/styledComponents";
import { allTrackers } from "app/services/track/track";
import { EKeywordTabs } from "app/UtilitiesAndConstants/Constants/SourceTypes";
import { proNavigator } from "single-spa/react-app/ProNavigator";

export const SerpPlayersPage: FunctionComponent = () => {
    const { selectedPageTabIndex, setSelectedPageTabIndex } = useSelectedPageTab(EKeywordTabs);
    const onPageTabSelect = (index: EKeywordTabs) => {
        const selectedTabKey = EKeywordTabs[index];
        setSelectedPageTabIndex(index);
        void proNavigator.updateParams({ selectedPageTab: selectedTabKey });
        allTrackers.dispatchTrackEvent(
            "Tab",
            "click",
            `Keyword Research/Keyword Explorer/${selectedTabKey} SERP Players`,
        );
    };

    return (
        <Tabs
            onSelect={onPageTabSelect}
            selectedIndex={selectedPageTabIndex}
        >
            <TabListStyled size={"lg"}>
                <Tab id={EKeywordTabs.Total}>{translate("keywordanalysis.tab.total.traffic")}</Tab>
                <Tab id={EKeywordTabs.Organic}>{translate("keywordanalysis.tab.organic.traffic")}</Tab>
                {isPaidKwSearchAvailable() ? (
                    <Tab id={EKeywordTabs.Paid}>{translate("keywordanalysis.tab.paid.traffic")}</Tab>
                ) : null}
            </TabListStyled>
            <SerpPlayers />
        </Tabs>
    );
};
